import React from 'react';
import './Footer.css';
const Footer = () => {
  return (
    <div>
      <div class="footer-inner"><span class="span">&copy;2022 by Fida Shnakher</span>
    <div class="call"><i class="fas fa-phone"></i>
      058-5141485
    </div>
   
    <div class="write"><i class="fas fa-envelope-open"></i> 
    fshnakher@gmail.com
    </div>
    <div class="follow">
      
    <div class='icons'>
      <a href="https://www.facebook.com/profile.php?id=100012226652201"><i class="fab fa-facebook fa-2x" ></i></a>
      <a href="https://github.com/fidashn"><i class="fab fa-github fa-2x"></i></a>
      <a href=" https://www.linkedin.com/in/fida-awida-shnakher-0b0b4a1b5"><i class="fab fa-linkedin fa-2x"></i></a>
    </div>
    </div>
    </div>
    </div>
    
  );
};

export default Footer;
